export default __webpack_public_path__ + "3bc6842d8256b83fa6842683654ef23f.jpeg";